import { useIntl } from 'react-intl';
import List from 'src/componentes/list';
import ListColumn from 'src/componentes/list/list-column';
import FaixaFarolEdit from './edit';
import LucideIcon from 'src/componentes/lucide-icon';
import HoverCard from 'src/componentes/hover-card';
import Preview from 'src/paginas/faixa-farol/preview';

const FaixaFarolList = ({
  modelItem,
  disabled,
  podeEditar,
  tipoItem,
  ...rest
}) => {
  const intl = useIntl();

  const renderFaixaFarol = (item) => {
    const melhor = modelItem?.getModel('melhor').value;
    const faixa = item.faixaFarol;

    let model = {
      value: null,
      tipoValorFaixa: faixa?.tipoValorFaixa,
      usarPontoFaixaResultado: false,
      interpolarValoresFaixa: false,
    };

    if (melhor != null && faixa != null) {
      if (melhor.id === 1) {
        model.value = faixa.faixaMaior;
        model.tipoValorFaixa = faixa.tipoValorFaixa;
        model.usarPontoFaixaResultado = faixa.usarPontoFaixaResultadoMelhorParaCima;
        model.interpolarValoresFaixa = faixa.interpolarValoresFaixaMelhorParaCima;
      } else if (melhor.id === 2) {
        model.value = faixa.faixaMenor;
        model.tipoValorFaixa = faixa.tipoValorFaixa;
        model.usarPontoFaixaResultado = faixa.usarPontoFaixaResultadoMelhorParaBaixo;
        model.interpolarValoresFaixa = faixa.interpolarValoresFaixaMelhorParaBaixo;
      } else {
        model.value = faixa.faixaIgual;
        model.tipoValorFaixa = faixa.tipoValorFaixa;
        model.usarPontoFaixaResultado = faixa.usarPontoFaixaResultadoMelhorIgual;
        model.interpolarValoresFaixa = faixa.interpolarValoresFaixaMelhorIgual;
      }
    }

    return model;
  };

  const renderDescricao = (item) => (
    <div className="d-flex align-items-center">
      <span>{item.descricaoFaixaFarol}</span>
      <HoverCard
        placement="left"
        title={intl.formatMessage({ id: 'faixaDeFarol' })}
        content={<Preview model={renderFaixaFarol(item)} />}
      >
        <LucideIcon
          icon="information-outline"
          size={16}
          style={{ marginLeft: 6, cursor: 'pointer' }}
        />
      </HoverCard>
    </div>
  );

  return (
    <div>
      <List
        url="/ItemFaixaFarol"
        showSearch={false}
        showTitle={true}
        title={intl.formatMessage({ id: 'faixaDeFarol' })}
        editComponent={FaixaFarolEdit}
        sort="dataInicio"
        parameters={{ ItemId: modelItem?.getModel('id').value }}
        showExport={false}
        showNew={!disabled && podeEditar}
        showEdit={!disabled && podeEditar}
        showDelete={!disabled && podeEditar}
        disabled={disabled}
        podeEditar={podeEditar}
        tipoItem={tipoItem}
        {...rest}
      >
        <ListColumn
          headerText={intl.formatMessage({ id: 'idIntegracao' })}
          valueField="idIntegracao"
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'dataInicio' })}
          valueField="dataInicio"
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'dataTermino' })}
          valueField="dataTermino"
        />
        <ListColumn
          headerText={intl.formatMessage({ id: 'descricao' })}
          valueField="descricaoFaixaFarol"
          valueFunction={renderDescricao}
        />
      </List>
    </div>
  );
};

export default FaixaFarolList;
